import { Action, OperationType } from '../../../../index';
export const CheckIfResourceExists: Action = [{
  condition: '{valid}',
  conditionOperations: [{
    condition: '{isSearchParams}',
    conditionOperations: [{
      data: {
        template: {
          method: 'head',
          bind: {
            url: '{url}',
            params: '{params}'
          }
        }
      },
      mappingName: 'resourceResponse',
      type: OperationType.request
    }],
    elseOperations: [{
      data: {
        template: {
          method: 'head',
          bind: {
            url: '{url}'
          },
          urlParams: {
            bind: {
              value: '{value}'
            }
          }
        }
      },
      mappingName: 'resourceResponse',
      type: OperationType.request
    }],
    type: OperationType.conditional
  }, {
    data: {
      template: {
        bind: {
          resourceExists: '{resourceResponse.resourceExists}'
        }
      }
    },
    type: OperationType.data
  }, {
    args: ['fieldName', 'pureValue', 'resourceExists'],
    name: 'onValidation',
    moduleName: 'PuzzleInputWithExistingValidation',
    evaluate: true,
    moduleId: '{moduleId}'
  }],
  elseOperations: [{
    args: ['fieldName', 'pureValue'],
    name: 'onValidation',
    moduleName: 'PuzzleInputWithExistingValidation',
    evaluate: true,
    moduleId: '{moduleId}'
  }],
  type: OperationType.conditional
}];

export const GetDataIfResourceExists: Action = [{
  data: {
    template: {
      method: 'get',
      url: '/testUsers',
      params: {
        bind: {
          email: '{email}'
        }
      }
    }
  },
  handleError: true,
  mappingName: 'response',
  type: OperationType.request
}, {
  args: ['response'],
  name: 'getData',
  moduleName: 'PuzzleInputWithExistingValidationExample',
  type: OperationType.addOperationData
}];
